import { reactive, toRefs } from 'vue'
import util from "@/util"
import Laboratory from '@/farm/Laboratory'
import MarkdownIt from 'markdown-it'

const state = reactive({
  loading: true,
  //researchInfo: reactive({}),
  researchTreeString: "",
  dialogueString: "",
  characterSequences: "",
  patchNotesString: "",
  debug: false
})

export default function globalState() {
  const load = async () => {
    state.loading = true

    // Load research tree
    let researchTree = await util.fetchHjson('research/research-tree.hjson')
    for (let node of researchTree.nodes) {
      node.thumb = 'research/' + node.thumb
    }
    state.researchTreeString = JSON.stringify(researchTree)

    // Load characters
    let characterList = await util.fetchHjson('characters/content.hjson')
    let characterInfos = []
    for (let characterId of characterList) {
      let info = await util.fetchHjson(`characters/${characterId}/info.hjson`)
      info.id = `characters/${characterId}`
      characterInfos.push(info)
    }
    state.characterSequences = JSON.stringify(characterInfos)

    // Load patch notes
    let patchList = await util.fetchHjson('patch-notes/content.hjson')
    let patches: any[] = []
    let md = new MarkdownIt()
    for (let patchId of patchList) {
      let patch = await util.fetchHjson(`patch-notes/${patchId}.hjson`)
      patch.id = patchId
      patch.text = md.render(patch.text)
      patches.push(patch)
    }
    state.patchNotesString = JSON.stringify(patches)

    // Load other things
    state.dialogueString = JSON.stringify(await util.fetchHjson('dialogue.hjson'))

    state.loading = false
  }

  return { ...toRefs(state), load }
}
